import PropTypes from "prop-types";
import React from "react";
import { Fetch } from "ui/fetch";

import { ConnectedDeviceFlags } from "./connected-flags";

class DeviceFlagsPage extends React.PureComponent {
  static get propTypes() {
    return {
      match: PropTypes.object.isRequired,
    };
  }

  render() {
    const { match } = this.props;
    const { deviceId } = match.params || {};

    return (
      <Fetch.Device deviceId={deviceId}>
        <ConnectedDeviceFlags />
      </Fetch.Device>
    );
  }
}

export { DeviceFlagsPage };
